export default class FacetsDropdown {

    constructor(element) {
        this.element = element;
        this.submit = this.element.querySelector('button');
        this.addEventListeners();
    }

    addEventListeners() {
        // Close menu when user clicks outside
        document.body.addEventListener('mousedown', (event) => {
            if (!this.element.contains(event.target)) {
                this.element.open = false;
            }
        });

        // Close menu when users focus another element
        this.element.addEventListener('focusout', (event) => {
            setTimeout(() => {
                if (!this.element.querySelector(':focus')) {
                    this.element.open = false;
                }
            }, 0);
        });

        this.submit.addEventListener('click', (event) => {
            this.element.open = false;
        });
    }

}
